<template>
  <AppSidebar :links="links">
  </AppSidebar>
</template>

<script>
import AppSidebar from "@/components/AppSidebar";


export default {
  data: () => ({
    links: [
      {
        icon: "fa fa-edit",
        text: "Eventos",
        path: "/admin/events"
      },
      {
        icon: "fa fa-clipboard-list",
        text: "Plantillas",
        path: "/admin/templates"
      }
    ]
  }),
  components: {
    AppSidebar
  }
};
</script>

<style lang='scss' scoped>
</style>